import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { stoneTypeService } from "@/services/stone-type/stoneTypeService";

export const useStoneTypeActions = () => {
    const { toast } = useToast();
    const { t } = useLanguage();
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const handleArchive = async (id: string) => {
        try {
            setIsLoading(true);
            await stoneTypeService.archive(id, user?.uid);
            toast({
                title: t("success"),
                description: t("stoneTypes.archived"),
            });
        } catch (error) {
            console.error("Error archiving stone type:", error);
            toast({
                title: t("error"),
                description: t("stoneTypes.archiveError"),
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleRestore = async (id: string) => {
        try {
            setIsLoading(true);
            await stoneTypeService.restore(id, user?.uid);
            toast({
                title: t("success"),
                description: t("stoneTypes.restored"),
            });
        } catch (error) {
            console.error("Error restoring stone type:", error);
            toast({
                title: t("error"),
                description: t("stoneTypes.restoreError"),
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleArchive,
        handleRestore,
        isLoading,
    };
}; 